<inventory-ui-item-selector
  [config]="config"
  [selectedItems]="selectedItems"
  (selectionChange)="itemSelectionChanged($event)"
/>
